import React from 'react';
import { Box, Typography } from '@mui/material';

// Contains a chart/KPI rendering crash to the widget itself instead of
// taking down the whole app -- see FH-103 (MultiKpiRenderer crashed the
// entire React tree when a panel's backing data was undefined, with no
// boundary anywhere upstream to catch it).
class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Chart rendering error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      const { colors } = this.props;
      return (
        <Box sx={{ p: 2, border: `1px solid ${colors?.border || '#333'}` }}>
          <Typography variant="body2" sx={{ color: colors?.textSecondary || 'text.secondary' }}>
            This chart could not be displayed.
          </Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ChartErrorBoundary;
